const gendersObject = {
  male: 1,
  female: 2,
};
const genderMapper = {
  1: 'Male',
  2: 'Female',
};
module.exports = {
  genderMapper,
  gendersObject,
};
// todo update this to store ENUM (male, female) directly in the database.
